import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    redirect: "/dashboard",
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("@/views/dashboard"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/info/country",
    name: "country",
    meta: {
      authRequired: true,
      permissions: ["CountryView"],
    },
    component: () => import("@/views/info/country"),
  },
  {
    path: "/info/oblast",
    name: "oblast",
    meta: {
      authRequired: true,
      permissions: ["OblastView"],
    },
    component: () => import("@/views/info/oblast"),
  },
  {
    path: "/info/region",
    name: "region",
    meta: {
      authRequired: true,
      permissions: ["RegionView"],
    },
    component: () => import("@/views/info/region"),
  },
  {
    path: "/info/department",
    name: "department",
    meta: {
      authRequired: true,
      permissions: ["DepartmentView"],
    },
    component: () => import("@/views/info/department"),
  },
  {
    path: "/info/educationlanguage",
    name: "educationlanguage",
    meta: {
      authRequired: true,
      permissions: ["EducationLanguageView"],
    },
    component: () => import("@/views/info/educationlanguage"),
  },
  {
    path: "/info/itemofexpense",
    name: "itemofexpense",
    meta: {
      authRequired: true,
      permissions: ["ItemOfExpenseView"],
    },
    component: () => import("@/views/info/itemofexpense"),
  },
  {
    path: "/info/mfy",
    name: "mfy",
    meta: {
      authRequired: true,
      permissions: ["MfyView"],
    },
    component: () => import("@/views/info/mfy"),
  },
  {
    path: "/info/mfystate",
    name: "mfystate",
    meta: {
      authRequired: true,
      permissions: ["MfyStateView"],
    },
    component: () => import("@/views/info/mfystate"),
  },
  {
    path: "/info/nationality",
    name: "nationality",
    meta: {
      authRequired: true,
      permissions: ["NationalityView"],
    },
    component: () => import("@/views/info/nationality"),
  },
  {
    path: "/info/oked",
    name: "oked",
    meta: {
      authRequired: true,
      permissions: ["OkedView"],
    },
    component: () => import("@/views/info/oked"),
  },
  {
    path: "/info/regiongroup",
    name: "regiongroup",
    meta: {
      authRequired: true,
      permissions: ["RegionGroupView"],
    },
    component: () => import("@/views/info/regiongroup"),
  },
  {
    path: "/info/regionstate",
    name: "regionstate",
    meta: {
      authRequired: true,
      permissions: ["RegionStateView"],
    },
    component: () => import("@/views/info/regionstate"),
  },
  {
    path: "/info/regiontype",
    name: "regiontype",
    meta: {
      authRequired: true,
      permissions: ["RegionTypeView"],
    },
    component: () => import("@/views/info/regiontype"),
  },
  {
    path: "/info/schoolgroupcontigent",
    name: "schoolgroupcontigent",
    meta: {
      authRequired: true,
      permissions: ["SchoolGroupContingentView"],
    },
    component: () => import("@/views/info/schoolgroupcontigent"),
  },
  {
    path: "/info/schoollegalform",
    name: "schoollegalform",
    meta: {
      authRequired: true,
      permissions: ["SchoolLegalFormView"],
    },
    component: () => import("@/views/info/schoollegalform"),
  },
  {
    path: "/info/schooltype",
    name: "schooltype",
    meta: {
      authRequired: true,
      permissions: ["SchoolTypeView"],
    },
    component: () => import("@/views/info/schooltype"),
  },
  {
    path: "/info/street",
    name: "street",
    meta: {
      authRequired: true,
      permissions: ["StreetView"],
    },
    component: () => import("@/views/info/street"),
  },
  {
    path: "/info/streethouse",
    name: "streethouse",
    meta: {
      authRequired: true,
      permissions: ["StreetHouseView"],
    },
    component: () => import("@/views/info/streethouse"),
  },
  {
    path: "/info/streethousestate",
    name: "streethousestate",
    meta: {
      authRequired: true,
      permissions: ["StreetHouseStateView"],
    },
    component: () => import("@/views/info/streethousestate"),
  },
  {
    path: "/info/streetstate",
    name: "streetstate",
    meta: {
      authRequired: true,
      permissions: ["StreetStateView"],
    },
    component: () => import("@/views/info/streetstate"),
  },
  {
    path: "/info/product",
    name: "product",
    meta: {
      authRequired: true,
      permissions: ["ProductView"],
    },
    component: () => import("@/views/info/product"),
  },
  {
    path: "/info/productcategory",
    name: "productcategory",
    meta: {
      authRequired: true,
      permissions: ["ProductCategoryView"],
    },
    component: () => import("@/views/info/productcategory"),
  },
  {
    path: "/info/tradetyperestriction",
    name: "tradetyperestriction",
    meta: {
      authRequired: true,
      permissions: ["ProductCategoryView"],
    },
    component: () => import("@/views/info/tradetyperestriction"),
  },
  {
    path: "/info/unitofmeasure",
    name: "unitofmeasure",
    meta: {
      authRequired: true,
      permissions: ["UnitOfMeasureView"],
    },
    component: () => import("@/views/info/unitofmeasure"),
  },
  {
    path: "/info/schoolyear",
    name: "schoolyear",
    meta: {
      authRequired: true,
      permissions: ["SchoolYearView"],
    },
    component: () => import("@/views/info/schoolyear"),
  },
  {
    path: "/info/schoolsubjectgroup",
    name: "schoolsubjectgroup",
    meta: {
      authRequired: true,
      permissions: ["SchoolSubjectGroupView"],
    },
    component: () => import("@/views/info/schoolsubjectgroup"),
  },
  {
    path: "/managment/organizationtype",
    name: "organizationtype",
    meta: {
      authRequired: true,
      permissions: ["OrganizationTypeView"],
    },
    component: () => import("@/views/managment/organizationtype"),
  },
  {
    path: "/managment/organizationaccount",
    name: "organizationaccount",
    meta: {
      authRequired: true,
      permissions: ["OrganizationAccountView"],
    },
    component: () => import("@/views/managment/organizationaccount"),
  },
  {
    path: "/managment/organization",
    name: "organization",
    meta: {
      authRequired: true,
      permissions: ["OrganizationView"],
    },
    component: () => import("@/views/managment/organization"),
  },
  {
    path: "/managment/role",
    name: "role",
    meta: {
      authRequired: true,
      permissions: ["RoleView"],
    },
    component: () => import("@/views/managment/role"),
  },
  {
    path: "/managment/user",
    name: "user",
    meta: {
      authRequired: true,
      permissions: ["UserView"],
    },
    component: () => import("@/views/managment/user"),
  },
  /////////Edit View --Info----/////////////////////////////////////
  {
    path: "/info/product/view/id=:id",
    name: "EditProduct",
    meta: {
      authRequired: true,
      permissions: ["ProductEdit"],
    },
    component: () => import("@/views/info/product/edit.vue"),
  },
  {
    path: "/info/productcategory/view/id=:id",
    name: "EditProductCategory",
    meta: {
      authRequired: true,
      permissions: ["ProductCategoryView"],
    },
    component: () => import("@/views/info/productcategory/edit.vue"),
  },
  {
    path: "/info/tradetyperestriction/view/id=:id",
    name: "EditTradeTypeRestriction",
    meta: {
      authRequired: true,
      permissions: ["TradeTypeRestrictionView"],
    },
    component: () => import("@/views/info/tradetyperestriction/edit.vue"),
  },
  {
    path: "/info/schoolsubjectgroup/view/id=:id",
    name: "EditSchoolSubjectGroup",
    meta: {
      authRequired: true,
      permissions: ["SchoolSubjectGroupView"],
    },
    component: () => import("@/views/info/schoolsubjectgroup/edit.vue"),
  },
  {
    path: "/info/schoolyear/view/id=:id",
    name: "EditSchoolYear",
    meta: {
      authRequired: true,
      permissions: ["SchoolYearView"],
    },
    component: () => import("@/views/info/schoolyear/edit.vue"),
  },
  /////////Edit View --Managment----/////////////////////////////////////
  {
    path: "/managment/role/view/id=:id",
    name: "EditRole",
    meta: {
      authRequired: true,
      permissions: ["RoleView"],
    },
    component: () => import("@/views/managment/role/edit.vue"),
  },
  {
    path: "/managment/user/view/id=:id",
    name: "EditUser",
    meta: {
      authRequired: true,
      permissions: ["UserView"],
    },
    component: () => import("@/views/managment/user/edit.vue"),
  },
  {
    path: "/managment/organizationaccount/view/id=:id",
    name: "EditOrganizationAccount",
    meta: {
      authRequired: true,
      permissions: ["OrganizationAccountView"],
    },
    component: () => import("@/views/managment/organizationaccount/edit.vue"),
  },
  ////////////////Document-----Edit-----//////////////////////////////////////
  {
    path: "/document/purreqplacement/edit/id=:id",
    name: "EditPurReqPlacement",
    meta: {
      authRequired: true,
      permissions: ["PurreqPlacementEdit"],
    },
    component: () => import("@/views/document/purreqplacement/edit.vue"),
  },
  {
    path: "/document/purchaserequisition/edit/id=:id",
    name: "EditPurchaseRequisition",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionEdit"],
    },
    component: () => import("@/views/document/purchaserequisition/edit.vue"),
  },
  {
    path: "/document/purchaserequisitionfornextyear/edit/id=:id",
    name: "EditPurchaseRequisitionForNextYear",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionForNextYearEdit"],
    },
    component: () =>
      import("@/views/document/purchaserequisitionfornextyear/edit.vue"),
  },
  {
    path: "/document/purchaserequisitiontotal/edit/id=:id",
    name: "EditPurchaseRequisitionTotal",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionTotalEdit"],
    },
    component: () =>
      import("@/views/document/purchaserequisitiontotal/edit.vue"),
  },
  {
    path: "/document/purreqtotalfornextyear/edit/id=:id",
    name: "EditPurReqTotalForNextYear",
    meta: {
      authRequired: true,
      permissions: ["PurReqTotalForNextYearEdit"],
    },
    component: () => import("@/views/document/purreqtotalfornextyear/edit.vue"),
  },
  ////////////////Document-----View-----//////////////////////////////////////
  {
    path: "/document/purchaserequisition/view/id=:id",
    name: "ViewPurchaseRequisition",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionView"],
    },
    component: () => import("@/views/document/purchaserequisition/view.vue"),
  },
  {
    path: "/document/purchaserequisitionfornextyear/view/id=:id",
    name: "ViewPurchaseRequisitionForNextYear",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionForNextYearView"],
    },
    component: () =>
      import("@/views/document/purchaserequisitionfornextyear/view.vue"),
  },
  {
    path: "/document/purchaserequisitiontotal/view/id=:id",
    name: "ViewPurchaseRequisitionTotal",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionTotalView"],
    },
    component: () =>
      import("@/views/document/purchaserequisitiontotal/view.vue"),
  },
  {
    path: "/document/purreqtotalfornextyear/view/id=:id",
    name: "ViewPurReqTotalForNextYear",
    meta: {
      authRequired: true,
      permissions: ["PurReqTotalForNextYearView"],
    },
    component: () => import("@/views/document/purreqtotalfornextyear/view.vue"),
  },
  ////////////////Document-----Index-----//////////////////////////////////////
  {
    path: "/document/purreqplacement",
    name: "purreqplacement",
    meta: {
      authRequired: true,
      permissions: ["PurreqPlacementView"],
    },
    component: () => import("@/views/document/purreqplacement"),
  },
  {
    path: "/document/purchaserequisition",
    name: "purchaserequisition",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionView"],
    },
    component: () => import("@/views/document/purchaserequisition"),
  },
  {
    path: "/document/purchaserequisitionfornextyear",
    name: "purchaserequisitionfornextyear",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionForNextYearView"],
    },
    component: () => import("@/views/document/purchaserequisitionfornextyear"),
  },

  {
    path: "/document/purchaserequisitiontotal",
    name: "purchaserequisitiontotal",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionTotalView"],
    },
    component: () => import("@/views/document/purchaserequisitiontotal"),
  },
  {
    path: "/document/purreqtotalfornextyear",
    name: "purreqtotalfornextyear",
    meta: {
      authRequired: true,
      permissions: ["PurReqTotalForNextYearView"],
    },
    component: () => import("@/views/document/purreqtotalfornextyear"),
  },
  ////////////////Document-----OherStatus-----//////////////////////////////////////
  {
    path: "/document/purchaserequisition/otherstatus.vue",
    name: "PurchaseRequisitionStatus",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionOtherStatusView"],
    },
    component: () =>
      import("@/views/document/purchaserequisition/otherstatus.vue"),
  },
  {
    path: "/document/purchaserequisitionfornextyear/otherstatus.vue",
    name: "PurchaseRequisitionStatusForNextYear",
    meta: {
      authRequired: true,
      permissions: ["PurchaseRequisitionForNextYearOtherStatusView"],
    },
    component: () =>
      import("@/views/document/purchaserequisitionfornextyear/otherstatus.vue"),
  },

  ///////////////////////////////////----------Reports------------/////////////////////////////////
  {
    path: "/Reports/GetAllUzexLot",
    name: "GetAllUzexLot",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetAllUzexLot"),
  },
  {
    path: "/Reports/ReportPurchaseRequisition",
    name: "ReportPurchaseRequisition",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/ReportPurchaseRequisition"),
  },
  {
    path: "/Reports/AuctionInfoByStatus",
    name: "AuctionInfoByStatus",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/AuctionInfoByStatus"),
  },
  {
    path: "/Reports/AuctionLotInfo",
    name: "AuctionLotInfo",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/AuctionLotInfo"),
  },
  {
    path: "/Reports/AuctionInfoByProvider",
    name: "AuctionInfoByProvider",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/AuctionInfoByProvider"),
  },
  {
    path: "/Reports/GetAuctionInfoByProviderPlatformAuction",
    name: "GetAuctionInfoByProviderPlatformAuction",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByProviderPlatformAuction"),
  },
  {
    path: "/Reports/GetAuctionInfoByProviderPlatformShop",
    name: "GetAuctionInfoByProviderPlatformShop",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByProviderPlatformShop"),
  },
  {
    path: "/Reports/GetAuctionInfoByProviderPlatformEtender",
    name: "GetAuctionInfoByProviderPlatformEtender",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByProviderPlatformEtender"),
  },
  {
    path: "/Reports/GetAuctionInfoByStatusAuction",
    name: "GetAuctionInfoByStatusAuction",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetAuctionInfoByStatusAuction"),
  },
  {
    path: "/Reports/GetAuctionInfoByStatusShop",
    name: "GetAuctionInfoByStatusShop",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetAuctionInfoByStatusShop"),
  },
  {
    path: "/Reports/GetAuctionInfoByStatusEtender",
    name: "GetAuctionInfoByStatusEtender",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetAuctionInfoByStatusEtender"),
  },
  {
    path: "/Reports/AuctionInfoByBuyer",
    name: "AuctionInfoByBuyer",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/AuctionInfoByBuyer"),
  },
  {
    path: "/Reports/GetAuctionInfoByBuyerPlatfromAuction",
    name: "GetAuctionInfoByBuyerPlatfromAuction",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByBuyerPlatfromAuction"),
  },
  {
    path: "/Reports/GetAuctionInfoByBuyerPlatfromShop",
    name: "GetAuctionInfoByBuyerPlatfromShop",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByBuyerPlatfromShop"),
  },
  {
    path: "/Reports/GetAuctionInfoByBuyerPlatfromEtender",
    name: "GetAuctionInfoByBuyerPlatfromEtender",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetAuctionInfoByBuyerPlatfromEtender"),
  },
  {
    path: "/Reports/TopMaxEconomyCostAuctionLotInfo",
    name: "TopMaxEconomyCostAuctionLotInfo",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/TopMaxEconomyCostAuctionLotInfo"),
  },
  {
    path: "/Reports/BudgetDirectlyList",
    name: "BudgetDirectlyList",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/BudgetDirectlyList"),
  },
  {
    path: "/Reports/TopMaxParticipantsCountAuctionLotInfo",
    name: "TopMaxParticipantsCountAuctionLotInfo",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/TopMaxParticipantsCountAuctionLotInfo"),
  },
  {
    path: "/Reports/TopMaxLotCountAuctionInfoByProvider",
    name: "TopMaxLotCountAuctionInfoByProvider",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/TopMaxLotCountAuctionInfoByProvider"),
  },
  {
    path: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformAuction",
    name: "GetTopMaxLotCountAuctionInfoByProviderPlatformAuction",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformAuction"
      ),
  },
  {
    path: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformShop",
    name: "GetTopMaxLotCountAuctionInfoByProviderPlatformShop",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformShop"
      ),
  },
  {
    path: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformEtender",
    name: "GetTopMaxLotCountAuctionInfoByProviderPlatformEtender",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformEtender"
      ),
  },
  {
    path: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction",
    name: "GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction"
      ),
  },
  {
    path: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformShop",
    name: "GetTopMaxTotalCostAuctionInfoByProviderPlatformShop",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformShop"
      ),
  },
  {
    path: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender",
    name: "GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import(
        "@/views/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender"
      ),
  },
  {
    path: "/Reports/TopMaxTotalCostAuctionInfoByProvider",
    name: "TopMaxTotalCostAuctionInfoByProvider",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/TopMaxTotalCostAuctionInfoByProvider"),
  },
  {
    path: "/Reports/ReportPurchaseRequisitionForNextYear",
    name: "ReportPurchaseRequisitionForNextYear",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/ReportPurchaseRequisitionForNextYear"),
  },
  {
    path: "/Reports/GetPurchasedProductsList",
    name: "GetPurchasedProductsList",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },

    component: require("@/views/Reports/GetPurchasedProductsList").default,
  },
  {
    path: "/Reports/ProviderCard",
    name: "ProviderCard",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("@/views/Reports/ProviderCard/index.vue"),
  },
  {
    path: "/Reports/BuyerCard",
    name: "BuyerCard",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("@/views/Reports/BuyerCard/index.vue"),
  },
  {
    path: "/Reports/GetProvidersByCategoryRisk",
    name: "GetProvidersByCategoryRisk",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("@/views/Reports/GetProvidersByCategoryRisk"),
  },
  {
    path: "/Reports/GetLotsByDumpingRisk",
    name: "GetLotsByDumpingRisk",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetLotsByDumpingRisk"),
  },
  {
    path: "/Reports/GetBuyersByProviderRisk",
    name: "GetBuyersByProviderRisk",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () =>
      import("@/views/Reports/GetBuyersByProviderRisk/index.vue"),
  },
  {
    path: "/Reports/BudgetAuctionList",
    name: "AuctionInfoByStatus",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/BudgetAuctionList"),
  },
  {
    path: "/Reports/GetBudgetShopList",
    name: "AuctionInfoByStatus",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetBudgetShopList"),
  },
  {
    path: "/Reports/GetBudgetEtenderList",
    name: "AuctionInfoByStatus",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/GetBudgetEtenderList"),
  },
  {
    path: "/Reports/BudgetOtborList",
    name: "BudgetOtborList",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/BudgetOtborList"),
  },
  {
    path: "/Reports/BudgetTenderList",
    name: "BudgetTenderList",
    meta: {
      authRequired: true,
      permissions: ["GetReportPurchaseRequisitionView"],
    },
    component: () => import("@/views/Reports/BudgetTenderList"),
  },
  {
    path: "/register",
    name: "Register",

    component: () => import("./views/account/register"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
      permissions: [],
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",

    component: () => import("./views/account/forgot-password"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
      permissions: [],
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
      permissions: [],
    },
  },
  {
    path: "/403",
    name: "403",
    component: require("./views/utility/403").default,
  },

  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "403",
  },
  {
    path: "*",
    redirect: "404",
  },

  {
    path: "/dashboard/saas",
    name: "saas-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/saas/index"),
  },
  {
    path: "/dashboard/crypto",
    name: "crypto-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/crypto/index"),
  },
  {
    path: "/dashboard/blog",
    name: "blog-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/blog/index"),
  },
  {
    path: "/calendar",
    name: "Calendar",
    meta: { authRequired: true },
    component: () => import("./views/calendar/calendar"),
  },
  {
    path: "/chat",
    name: "chat",
    meta: { authRequired: true },
    component: () => import("./views/chat/index"),
  },
  {
    path: "/apps/file-manager",
    name: "file-manager",
    meta: { authRequired: true },
    component: () => import("./views/file-manager/index"),
  },
  {
    path: "/ecommerce/products",
    name: "Products",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-detail/:id",
    name: "Product Detail",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/product-detail"),
  },
  {
    path: "/ecommerce/orders",
    name: "Orders",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/orders"),
  },
  {
    path: "/ecommerce/customers",
    name: "Customers",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/customers"),
  },
  {
    path: "/ecommerce/cart",
    name: "Cart",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/cart"),
  },
  {
    path: "/ecommerce/checkout",
    name: "Checkout",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/shops",
    name: "Shops",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/shops"),
  },
  {
    path: "/ecommerce/add-product",
    name: "Add Product",
    meta: { authRequired: true },
    component: () => import("./views/ecommerce/add-product"),
  },
  {
    path: "/blog/list",
    name: "blog-list",
    meta: { authRequired: true },
    component: () => import("./views/blog/list"),
  },
  {
    path: "/blog/grid",
    name: "blog-grid",
    meta: { authRequired: true },
    component: () => import("./views/blog/grid"),
  },
  {
    path: "/blog/detail",
    name: "blog-detail",
    meta: { authRequired: true },
    component: () => import("./views/blog/detail"),
  },
  {
    path: "/crypto/wallet",
    name: "Wallet",
    meta: { authRequired: true },
    component: () => import("./views/crypto/wallet/index"),
  },
  {
    path: "/crypto/buy-sell",
    name: "Buy/sell",
    meta: { authRequired: true },
    component: () => import("./views/crypto/buysell/index"),
  },
  {
    path: "/crypto/exchange",
    name: "Exchange",
    meta: { authRequired: true },
    component: () => import("./views/crypto/exchange/index"),
  },
  {
    path: "/crypto/lending",
    name: "Lending",
    meta: { authRequired: true },
    component: () => import("./views/crypto/lending/index"),
  },
  {
    path: "/crypto/orders",
    name: "crypto-orders",
    meta: { authRequired: true },
    component: () => import("./views/crypto/orders/index"),
  },
  {
    path: "/crypto/kyc-application",
    name: "kyc-application",
    meta: { authRequired: true },
    component: () => import("./views/crypto/kycapplication/index"),
  },
  {
    path: "/crypto/ico-landing",
    name: "Ico-landing",
    meta: { authRequired: true },
    component: () => import("./views/crypto/ico-landing"),
  },
  {
    path: "/invoices/detail",
    name: "Invoice Detail",
    meta: { authRequired: true },
    component: () => import("./views/invoices/detail"),
  },
  {
    path: "/invoices/list",
    name: "Invoice List",
    meta: { authRequired: true },
    component: () => import("./views/invoices/list"),
  },
  {
    path: "/ui/alerts",
    name: "Alerts",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/ui/alerts"),
  },
  {
    path: "/ui/buttons",
    name: "Buttons",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/ui/buttons"),
  },
  {
    path: "/ui/cards",
    name: "Cards",
    meta: { authRequired: true },
    component: () => import("./views/ui/cards"),
  },
  {
    path: "/ui/carousel",
    name: "Carousel",
    meta: { authRequired: true },
    component: () => import("./views/ui/carousel"),
  },
  {
    path: "/ui/dropdowns",
    name: "Dropdowns",
    meta: { authRequired: true },
    component: () => import("./views/ui/dropdowns"),
  },
  {
    path: "/ui/grid",
    name: "Grid",
    meta: { authRequired: true },
    component: () => import("./views/ui/grid"),
  },
  {
    path: "/ui/images",
    name: "Images",
    meta: { authRequired: true },
    component: () => import("./views/ui/images"),
  },
  {
    path: "/ui/modals",
    name: "Modals",
    meta: { authRequired: true },
    component: () => import("./views/ui/modals"),
  },
  {
    path: "/ui/drawer",
    name: "Drawer",
    meta: { authRequired: true },
    component: () => import("./views/ui/drawer"),
  },
  {
    path: "/ui/rangeslider",
    name: "Rangeslider",
    meta: { authRequired: true },
    component: () => import("./views/ui/rangeslider"),
  },
  {
    path: "/ui/progressbars",
    name: "Progressbars",
    meta: { authRequired: true },
    component: () => import("./views/ui/progressbars"),
  },
  {
    path: "/ui/sweet-alert",
    name: "Sweet-alert",
    meta: { authRequired: true },
    component: () => import("./views/ui/sweet-alert"),
  },
  {
    path: "/ui/tabs-accordions",
    name: "Tabs-accordions",
    meta: { authRequired: true },
    component: () => import("./views/ui/tabs-accordions"),
  },
  {
    path: "/ui/typography",
    name: "Typography",
    meta: { authRequired: true },
    component: () => import("./views/ui/typography"),
  },
  {
    path: "/ui/video",
    name: "Video",
    meta: { authRequired: true },
    component: () => import("./views/ui/video"),
  },
  {
    path: "/ui/general",
    name: "General",
    meta: { authRequired: true },
    component: () => import("./views/ui/general"),
  },
  {
    path: "/ui/colors",
    name: "Colors",
    meta: { authRequired: true },
    component: () => import("./views/ui/colors"),
  },
  {
    path: "/ui/lightbox",
    name: "Lightbox",
    meta: { authRequired: true },
    component: () => import("./views/ui/lightbox"),
  },
  {
    path: "/ui/image-cropper",
    name: "Image Cropper",
    meta: { authRequired: true },
    component: () => import("./views/ui/cropper"),
  },
  {
    path: "/projects/grid",
    name: "Projects Grid",
    meta: { authRequired: true },
    component: () => import("./views/projects/projects-grid"),
  },
  {
    path: "/projects/list",
    name: "Projects List",
    meta: { authRequired: true },
    component: () => import("./views/projects/projects-list"),
  },
  {
    path: "/projects/overview",
    name: "Project Overview",
    meta: { authRequired: true },
    component: () => import("./views/projects/overview"),
  },
  {
    path: "/projects/create",
    name: "Create New",
    meta: { authRequired: true },
    component: () => import("./views/projects/create"),
  },
  {
    path: "/contacts/grid",
    name: "User Grid",
    meta: { authRequired: true },
    component: () => import("./views/contacts/contacts-grid"),
  },
  {
    path: "/contacts/list",
    name: "User List",
    meta: { authRequired: true },
    component: () => import("./views/contacts/contacts-list"),
  },
  {
    path: "/contacts/profile",
    name: "Profile",
    meta: { authRequired: true },
    component: () => import("./views/contacts/contacts-profile"),
  },
  {
    path: "/charts/apex",
    name: "Apex chart",
    meta: { authRequired: true },
    component: () => import("./views/charts/apex"),
  },
  {
    path: "/charts/chartjs",
    name: "Chartjs chart",
    meta: { authRequired: true },
    component: () => import("./views/charts/chartjs/index"),
  },
  {
    path: "/charts/chartist",
    name: "Chartist chart",
    meta: { authRequired: true },
    component: () => import("./views/charts/chartist"),
  },
  {
    path: "/charts/echart",
    name: "Echart chart",
    meta: { authRequired: true },
    component: () => import("./views/charts/echart/index"),
  },
  {
    path: "/icons/boxicons",
    name: "Boxicons Icon",
    meta: { authRequired: true },
    component: () => import("./views/icons/boxicons"),
  },
  {
    path: "/icons/materialdesign",
    name: "Materialdesign Icon",
    meta: { authRequired: true },
    component: () => import("./views/icons/materialdesign"),
  },
  {
    path: "/icons/dripicons",
    name: "Dripicons Icon",
    meta: { authRequired: true },
    component: () => import("./views/icons/dripicons"),
  },
  {
    path: "/icons/fontawesome",
    name: "Fontawesome Icon",
    meta: { authRequired: true },
    component: () => import("./views/icons/fontawesome"),
  },
  {
    path: "/maps/google",
    name: "Google Maps",
    meta: { authRequired: true },
    component: () => import("./views/maps/google"),
  },
  {
    path: "/maps/leaflet",
    name: "Leaflet Maps",
    meta: { authRequired: true },
    component: () => import("./views/maps/leaflet/index"),
  },
  {
    path: "/tables/basic",
    name: "Basic Tables",
    meta: { authRequired: true },
    component: () => import("./views/tables/basictable"),
  },
  {
    path: "/tables/advanced",
    name: "Advanced Tables",
    meta: { authRequired: true },
    component: () => import("./views/tables/advancedtable"),
  },
  {
    path: "/form/advanced",
    name: "Form Advanced",
    meta: { authRequired: true },
    component: () => import("./views/forms/advanced"),
  },
  {
    path: "/form/elements",
    name: "Form Elements",
    meta: { authRequired: true },
    component: () => import("./views/forms/elements"),
  },
  {
    path: "/form/layouts",
    name: "Form Layouts",
    meta: { authRequired: true },
    component: () => import("./views/forms/layouts"),
  },
  {
    path: "/form/editor",
    name: "Form Editors",
    meta: { authRequired: true },
    component: () => import("./views/forms/editors"),
  },
  {
    path: "/form/uploads",
    name: "File Uploads",
    meta: { authRequired: true },
    component: () => import("./views/forms/uploads"),
  },
  {
    path: "/form/validation",
    name: "Form Validation",
    meta: { authRequired: true },
    component: () => import("./views/forms/validation"),
  },
  {
    path: "/form/wizard",
    name: "Form Wizard",
    meta: { authRequired: true },
    component: () => import("./views/forms/wizard"),
  },
  {
    path: "/form/repeater",
    name: "Form Repeater",
    meta: { authRequired: true },
    component: () => import("./views/forms/repeater"),
  },
  {
    path: "/form/mask",
    name: "Form Mask",
    meta: { authRequired: true },
    component: () => import("./views/forms/mask"),
  },
  {
    path: "/pages/starter",
    name: "Starter",
    meta: { authRequired: true },
    component: () => import("./views/utility/starter"),
  },
  {
    path: "/pages/maintenance",
    name: "Maintenance",
    meta: { authRequired: true },
    component: () => import("./views/utility/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { authRequired: true },
    component: () => import("./views/utility/coming-soon"),
  },
  {
    path: "/pages/timeline",
    name: "Timeline",
    meta: { authRequired: true },
    component: () => import("./views/utility/timeline"),
  },
  {
    path: "/pages/faqs",
    name: "FAQs",
    meta: { authRequired: true },
    component: () => import("./views/utility/faqs"),
  },
  {
    path: "/pages/pricing",
    name: "Pricing",
    meta: { authRequired: true },
    component: () => import("./views/utility/pricing"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/403",
    name: "Error-403",
    meta: { authRequired: true },
    component: () => import("./views/utility/403"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },
  {
    path: "/email/inbox",
    name: "Inbox",
    meta: { authRequired: true },
    component: () => import("./views/email/inbox"),
  },
  {
    path: "/email/reademail/:id",
    name: "Read Email",
    meta: { authRequired: true },
    component: () => import("./views/email/reademail"),
  },
  {
    path: "/email/templates/basic",
    name: "Email template basic",
    meta: { authRequired: true },
    component: () => import("./views/email/templates/basic"),
  },
  {
    path: "/email/templates/billing",
    name: "Email template billing",
    meta: { authRequired: true },
    component: () => import("./views/email/templates/billing"),
  },
  {
    path: "/email/templates/alert",
    name: "Email template alert",
    meta: { authRequired: true },
    component: () => import("./views/email/templates/alert"),
  },
  {
    path: "/tasks/list",
    name: "Task list",
    meta: { authRequired: true },
    component: () => import("./views/tasks/task-list"),
  },
  {
    path: "/tasks/kanban",
    name: "Kanbanboard",
    meta: { authRequired: true },
    component: () => import("./views/tasks/kanbanboard"),
  },
  {
    path: "/tasks/create",
    name: "Create Task",
    meta: { authRequired: true },
    component: () => import("./views/tasks/task-create"),
  },
  {
    path: "/auth/login-1",
    name: "Login sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/login-sample"),
  },
  {
    path: "/auth/login-2",
    name: "Login-2-sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/login-2"),
  },
  {
    path: "/auth/register-1",
    name: "Register sample",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/register-sample"),
  },
  {
    path: "/auth/register-2",
    name: "Register-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/register-2"),
  },
  {
    path: "/auth/recoverpwd",
    name: "Recover pwd",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/recoverpw-sample"),
  },
  {
    path: "/auth/recoverpwd-2",
    name: "Recover pwd-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/recoverpwd-2"),
  },
  {
    path: "/auth/lock-screen",
    name: "Lock screen",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/lockscreen"),
  },
  {
    path: "/auth/lock-screen-2",
    name: "Lock screen-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/lockscreen-2"),
  },
  {
    path: "/auth/confirm-mail",
    name: "confirm-mail",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/confirm-mail"),
  },
  {
    path: "/auth/confirm-mail-2",
    name: "confirm-mail-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/confirm-mail-2"),
  },
  {
    path: "/auth/email-verification",
    name: "email-verification",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/email-verification"),
  },
  {
    path: "/auth/email-verification-2",
    name: "email-verification-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/email-verification-2"),
  },
  {
    path: "/auth/two-step-verification",
    name: "two-step-verification",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/two-step-verification"),
  },
  {
    path: "/auth/two-step-verification-2",
    name: "two-step-verification-2",
    meta: { authRequired: true },
    component: () => import("./views/sample-pages/two-step-verification-2"),
  },
];
